import React from "react";

/**
 * What a tenant's page shows while a split-out chunk is on its way.
 *
 * Every public page chooses between the Estate design and the classic one on
 * what the agency's record says, and the classic half is fetched on demand
 * (see pages/classic/). That fetch takes a round trip, and whatever stands in
 * for the page meanwhile has to reserve a screen: a shorter placeholder lets
 * the footer paint near the top of the viewport and then get pushed down when
 * the real page arrives, which is a layout shift on somebody's homepage.
 *
 * A full viewport, and nothing drawn in it. The page that replaces it is at
 * least this tall, so nothing below it moves.
 */
export const SITE_FALLBACK = <div style={{ minHeight: "100vh" }} />;
